export default "__VITE_ASSET__DZlApoNu__"